<template>
	<v-dialog v-model="labelChangeDialog" width="600px">
    <customDialog>
      <template v-slot:title>
        {{t('askSelectLabel')}}
        <button id="dialog_exit" @click="labelChangeDialog = false">
          <img src="@/assets/images/popup_close.png" id="btn_img">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0 pt-7 pb-10 dialog_text" align="center">
              <v-col class="ma-0 pa-0" cols="12">
                <v-select class="ma-0 pa-0" v-model="selectedLabelId"
									:items="labelList" dense hide-details outlined placeholder="選択してください"
									dark item-text="labelName" item-value="id"
								></v-select>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
             	<v-btn class="ma-0 pa-0" id="grey_btn" width="8rem" height="2rem"
						 		@click="labelChangeDialog = false">{{t('cancel')}}</v-btn>
             	<v-btn class="ma-0 pa-0 ml-2" id="blue_btn" width="8rem" height="2rem"
							 	@click="confirm" :loading="loading">{{t('change')}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';

export default {
	props: {
		dialogVisible: Boolean,
	},
	components: {
		customDialog
	},
	mixins: [mixin.common],
	data: () => ({
		labelChangeDialog: false,
		groupLabelList: [],
		selectedLabelId: null,
		loading: false,
	}),
	computed: {
		labelList() {
			let result = [];
			this.groupLabelList.forEach((label) => {
				if(label.labelName) {
					result.push(label);
				}
			})
			result.push({ labelName: '未選択', id: '' });
			return result;
		}
	},
	watch: {
		dialogVisible: function(isVisible) {
			this.labelChangeDialog = isVisible;
		},
		labelChangeDialog: function(item) {
			this.$emit('visible', item);
			if(item) this.groupLabelList = this.$store.getters.getStoreGroupLabel;
			this.selectedLabelId = null;
		},
	},
  mounted() {
    
  },
  methods: {
		confirm() {
			if(this.selectedLabelId == null) return;
			this.loading = true;
			let params = {
        storeGroupLabelId: this.selectedLabelId
      };
      this.networkController.updateStoreGroup(params, this.$route.query.groupId)
      .then(async (res) => {
				console.log(res.data);
				this.loading = false;
				this.$emit('update', true);
				this.labelChangeDialog = false;
				this.showToastMessage(this.tmb('requestSuccess'));
			}).catch(error => {
				this.showToastMessage(this.tmb('requestFail'));
				this.loading = false;
			});
		}
  }
}
</script>

<style lang="scss" scoped>
.v-list{
  background: #171921;
	border: 1px solid #4A4A4A;
	overflow: auto;
  max-height: 200px;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
}
</style>